import * as React from 'react';
import * as styles from './styles.css';

import { getUnits } from './utils';
import { Star } from './Star';
import cn from 'clsx';

export type TSize = 'S' | 'M';

export interface IStarsProps {
  uniqueKey: string;
  value: number;
  size?: TSize;
}

const STARS_COUNT = 5;

export function Stars(props: IStarsProps) {
  const { uniqueKey, value, size = 'S' } = props;
  const units = getUnits(STARS_COUNT, value);

  return (
    <ul className={cn(styles['stars'], styles[`stars-size_${size.toLocaleLowerCase()}`])}>
      {units.map((value, index) => {
        const key = `${uniqueKey}-${index}`;

        return (
          <li key={key}>
            <Star gradientId={key} value={value} />
          </li>
        );
      })}
    </ul>
  );
}
